export default {
    "name": "DeleteVehicleAttachments",
    "kind": "HoudiniMutation",
    "hash": "45adde3b7875d8d5ee2f6f5ea6df55bc036363446e1e6f735e3219709eef850b",

    "raw": `mutation DeleteVehicleAttachments($ids: [UInt!]!) {
  deleteVehicleAttachments(ids: $ids)
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "deleteVehicleAttachments": {
                "type": "UInt",
                "keyRaw": "deleteVehicleAttachments(ids: $ids)",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "ids": "UInt"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=df1ea158129135d887abdf11e84b574fefad536198067274050bfaef0068e233";